"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerNudgeAnimation = triggerNudgeAnimation;
exports.triggerStrobeAnimation = triggerStrobeAnimation;
function triggerNudgeAnimation(btn, count) {
    // --- 0. Validate ---
    const isMskuRefresh = sessionStorage.getItem('isMskuRefresh');
    sessionStorage.removeItem('isMskuRefresh');
    if (isMskuRefresh) {
        count.hidden = false;
        return;
    }
    // --- 1. Measure ---
    count.style.opacity = '0';
    const collapsedWidth = btn.offsetWidth;
    count.hidden = false;
    const expandedWidth = btn.offsetWidth;
    // --- 2. Animate ---
    btn.style.setProperty('--w-start', `${collapsedWidth}px`);
    btn.style.setProperty('--w-end', `${expandedWidth}px`);
    btn.classList.add('nudge');
    // --- 3. Cleanup ---
    btn.addEventListener('animationend', () => {
        btn.classList.remove('nudge');
        btn.style.removeProperty('--w-start');
        btn.style.removeProperty('--w-end');
        count.style.opacity = '';
    }, { once: true });
}
function triggerStrobeAnimation(btn, { onStart, onEnd }) {
    onStart === null || onStart === void 0 ? void 0 : onStart();
    const handler = (evt) => {
        const e = evt;
        if (e.animationName === 'flicker') {
            btn === null || btn === void 0 ? void 0 : btn.removeEventListener('animationend', handler);
            onEnd === null || onEnd === void 0 ? void 0 : onEnd();
        }
    };
    btn === null || btn === void 0 ? void 0 : btn.addEventListener('animationend', handler);
}
